// extracted by mini-css-extract-plugin
module.exports = {"body":"Circulos_body__2aGyV","circulos":"Circulos_circulos__2rh4V","imgCirculo":"Circulos_imgCirculo__1o9li"};